<script>

import { useToast } from "vue-toastification";
import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getStateOptions } from '@/services/serviceCommon';
import { getAccessRightsOptions } from '@/services/serviceAccessRight';
import { getMod, unlockMod, saveMod, createMod } from '@/services/serviceMod'

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'ModEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'modId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["modId","changeRecord"],
	data() {
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			optionsAccessLevels:[],
			optionsStates:[],
			
			//form
			data:[]
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true
			
			getMod({modId:this.modId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getAccessRightsOptions().then(response => {
				if(!response.statusText){
					this.optionsAccessLevels = response.optionsAccessLevels;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getStateOptions().then(response => {
				if(!response.statusText){
					this.optionsStates = response.optionsStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},
	
		checkSave:function(){
				
			if(!this.data.title){this.data.titleError = true;}else{this.data.titleError = false;}
			if(!this.data.url){this.data.urlError = true;}else{this.data.urlError = false;}
			if(!this.data.access){this.data.accessError = true;}else{this.data.accessError = false;}
			if(!this.data.state){this.data.stateError = true;}else{this.data.stateError = false;}
			
			if(!this.data.titleError && !this.data.accessError && !this.data.stateError && !this.data.urlError){
				return true;
			}else{
				this.toast.warning(this.$t('msgCore.fillInAllData'));
				return false;
			}
		},	
		
		onSave:function(){
				
			if(this.checkSave()){
				if(this.modId!='null'){	
					this.isSending=true
					saveMod({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{	
					createMod({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}
			}
			
		},

		onClose:function(){
			if(this.modId!='null'){
				unlockMod({modId:this.modId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		
		
	},
	
	watch: {
		modId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCore.Mod') }} <span v-if="data.isNewRecord">{{ $tc('msgCore.new',0) }}</span><span v-else>id: <b>{{ data.title }}</b> {{data.id}}</span></h6>
						
						
					</div>
			
							<div v-if="metaData.modulAccess && (auth.modsEdit || auth.modsNew)" class="modal-body">
								
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<span v-if="data.isCheckedOut" class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}" v-bind:title="data.isCheckedOutName+', '+data.isCheckedOutDate">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</span>
										</div>
									</div>
								</div>
								
								<div class="row">
									
									<div class="col-md-8 col-12">
									
											<div class="row">
												
												<div class="col-md-2 col-3">
													<label><b>{{ $t('msgCore.ID') }}</b></label>
													<input type="text" class="form-control form-control-sm" v-model="data.id" >
													
												</div>
											
												<div class="col-md-10 col-12">
													<label :class="{'text-danger':data.titleError}"><b>{{ $t('msgCore.Title') }}</b> </label>
													<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.titleError}" v-on:change="checkSave()" v-model="data.title" >
													<div v-show="data.titleError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
												</div>
												
												
												
												<div class="col-md-6 col-12">
													<label :class="{'text-danger':data.urlError}"><b>{{ $t('msgCore.url') }}</b></label>
													<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.urlError}" v-model="data.url">
													<div v-show="data.urlError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
												</div>
												
												<div class="col-md-4 col-8">
													<label :class="{'text-danger':data.accessModError}"><b>{{ $t('msgCore.Access') }}</b></label>
																										
													<select v-model='data.accessMod' class="form-control form-control-sm " :class="{'is-invalid':data.accessModError}" v-on:change="checkSave()">
														<option  value="">{{ $t('msgCore.selectLevel') }}</option>
														<option v-for="(option) in optionsAccessLevels"  :key="option" :value="option.value">{{ option.title }}</option>
													</select>
													<div v-show="data.accessModError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectLevel')}}</span></div>
												</div>
												
												<div class="col-md-2 col-4">
													<label for="sum"><b>{{ $t('msgCore.Version') }}</b> </label><br>
													<input type="text" class="form-control form-control-sm" v-model="data.version">
												</div>												
												
												
											</div>	
									</div>
									
									<div class="col-md-4 col-12 form-control-system-data">
									
										<div class="col-12">
											<label :class="{'text-danger':data.accessError}"><b>{{ $t('msgCore.AccessLevel') }}</b></label>
																								
											<select v-model='data.access' class="form-control form-control-sm " :class="{'is-invalid':data.accessError}" v-on:change="checkSave()">
												<option  value="">{{ $t('msgCore.selectLevel') }}</option>
												<option v-for="(option) in optionsAccessLevels" :key="option" :value="option.value">{{ option.title }}</option>
											</select>
											<div v-show="data.accessError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectLevel')}}</span></div>
										</div>
																						
										
										<div class="col-12">
											<label :class="{'text-danger':data.stateError}"><b>{{ $t('msgCore.State') }}</b></label>
											
												<div  v-for="(option) in optionsStates" :key="option"  class="form-check">
												<label class="form-check-label">
													<input class="form-check-input" type="radio" name="optionsStates"  v-model='data.state' v-on:change="checkSave()" :value="option.value">
														{{ $t('msgCore.'+option.title) }}
													<span class="circle">
													<span class="check"></span>
													</span>
												</label>
												</div>
											<div v-show="data.stateError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectState')}}</span></div>
										</div>
									
									</div>
									
								</div>	
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12 mt-3">
										<Alert type="warning" :label="$t('msgCore.accessDenied')" />
									</div>
								</div>
							</div>
							
							
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
								
									<LoadingButton :isDisabled="((!auth.modsEdit) || (!auth.modsNew) || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
	</div>
</template>


